import Vue from 'vue';
import Vuex from 'vuex';
import MyPlusAppApi from '../api/my-plus-api';

Vue.use(Vuex);

const initialState = () => {
  return {
    myPlusAppList: [],
  };
};

const getters = {
  getMyPlusAppList(state) {
    return state.myPlusAppList;
  },
};

const mutations = {
  setMyPlusAppList(state, myPlusAppList) {
    state.myPlusAppList = myPlusAppList;
  },
};

const actions = {
  async fetchMyPlusAppList({ commit }) {
    const options = { url: '/bookmarks' };
    const response = await MyPlusAppApi.getMyPlusAppList({ options });

    commit('setMyPlusAppList', response.data.data);
  },
};

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
  getters,
  strict: process.env.NODE_ENV !== 'production',
};
